import Vue from "vue"
import { dictionary } from './constants'

import { 
  ValidationProvider,
  ValidationObserver,
  localize
} from "vee-validate"

Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)

const locale = document.documentElement.lang

localize(locale, dictionary[locale])



// WEBPACK FOOTER //
// ./src/js/validation/components.js